var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33338 0H18.3336C20.1744 0 21.667 1.49252 21.667 3.33338V13.3335C21.667 15.1744 20.1744 16.6669 18.3336 16.6669H9.39334C8.176 18.7424 5.92052 19.9583 3.83674 19.9911C3.80887 19.997 3.77997 20.0001 3.75035 20.0001C3.52023 20.0001 3.33368 19.8135 3.33368 19.5834C3.33368 19.401 3.45088 19.246 3.61408 19.1895C4.81953 18.6302 5.28959 17.643 5.44866 16.6669H3.33338C1.49252 16.6669 0 15.1744 0 13.3335V3.33338C0 1.49252 1.49252 0 3.33338 0ZM9.16679 8.33345C9.16679 9.25429 9.91263 10.0001 10.8335 10.0001C11.7543 10.0001 12.5002 9.25429 12.5002 8.33345C12.5002 7.4126 11.7543 6.66676 10.8335 6.66676C9.91263 6.66676 9.16679 7.4126 9.16679 8.33345ZM14.1669 8.33345C14.1669 9.25429 14.9127 10.0001 15.8335 10.0001C16.7544 10.0001 17.5002 9.25429 17.5002 8.33345C17.5002 7.4126 16.7544 6.66676 15.8335 6.66676C14.9127 6.66676 14.1669 7.4126 14.1669 8.33345ZM4.16672 8.33345C4.16672 9.25429 4.91257 10.0001 5.83341 10.0001C6.75426 10.0001 7.5001 9.25429 7.5001 8.33345C7.5001 7.4126 6.75426 6.66676 5.83341 6.66676C4.91257 6.66676 4.16672 7.4126 4.16672 8.33345Z",
    fill: "#C4BBFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSms);
export default __webpack_public_path__ + "static/media/SMS.5fd4207e.svg";
export { ForwardRef as ReactComponent };